<template>
  <tg-list class="tg-url-list" :key="$route.fullPath">
    <template v-if="$user.group == 20 && $user.permissions[34] >= 1">
      <tg-collapse
        :title="title.self_promote"
        showStatic
        :showArrow="false"
        style="width: 100%"
      >
        <template slot="collapse-static-item">
          <div v-for="(item, i) in self_promotes" :key="i">
            <tg-url-copy :url="item"></tg-url-copy>
          </div>
        </template>
      </tg-collapse>
    </template>
    <template v-if="$user?.permissions && $user?.permissions[33] >= 1">
      <tg-collapse
        @on-arrow-click="handleCollapseClick('m')"
        v-model="expandMobile"
        :title="title.mobile"
        showStatic
        :showArrow="m_list.length > 0"
      >
        <template slot="collapse-static-item">
          <div v-for="(item, i) in m_static" :key="i">
            <tg-url-copy :url="item"></tg-url-copy>
          </div>
        </template>

        <div v-for="(item, i) in m_list" :key="i">
          <tg-url-copy :url="item"></tg-url-copy>
        </div>
      </tg-collapse>

      <tg-collapse
        @on-arrow-click="handleCollapseClick('pc')"
        v-model="expandPC"
        :title="title.pc"
        showStatic
        :showArrow="pc_list.length > 0"
      >
        <template slot="collapse-static-item">
          <div v-for="(item, i) in pc_static" :key="i">
            <tg-url-copy :url="item"></tg-url-copy>
          </div>
        </template>

        <div v-for="(item, i) in pc_list" :key="i">
          <tg-url-copy :url="item"></tg-url-copy>
        </div>
      </tg-collapse>
    </template>
  </tg-list>
</template>

<script>
import TgList from "../list/TgList";
import TgCollapse from "../collapse/TgCollapse";
import TgUrlCopy from "../normal/TgUrlCopy";
export default {
  components: {
    TgList,
    TgCollapse,
    TgUrlCopy,
  },
  data() {
    return {
      expandPC: false,
      expandMobile: false,
      dd: 0,
    };
  },
  computed: {
    title() {
      return {
        mobile: this.$t("title.tg_mobile"),
        pc: this.$t("title.tg_web"),
        self_promote: this.$t("title.self_promote"),
      };
    },
    url() {
      return this.$store.state.app.url;
    },
    m_static() {
      let list = this.url ? this.url.mobile : [];
      return list.slice(0, 2);
    },
    m_list() {
      let list = this.url ? this.url.mobile : [];

      return list.slice(2);
    },
    pc_static() {
      let list = this.url ? this.url.web : [];

      return list.slice(0, 2);
    },
    pc_list() {
      let list = this.url ? this.url.web : [];

      return list.slice(2);
    },
    self_promotes() {
      let register = "/register.php?agent=" + this.$user.username;

      let list = [this.url.web[0] + register, this.url.mobile[0] + register];

      return list;
    },
  },
  methods: {
    handleCollapseClick(type) {
      let m = this.expandMobile;
      let pc = this.expandPC;

      if (type === "m") {
        if (!m) {
          this.expandPC = false;
        }
        this.expandMobile = !this.expandMobile;
      }

      if (type === "pc") {
        if (!pc) {
          this.expandMobile = false;
        }
        this.expandPC = !this.expandPC;
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.dd = this.dd > 0 ? 0 : 1;
    next();
  },
};
</script>
